import { serviceLogMatrixPath } from './constants';
import { baseAutomationUrl } from 'src/config';
import { getAccessToken, getRealmName } from 'src/routes/AuthContext';
import { IServiceLogGetParams } from './types';
import axios from 'axios';
import { getClientIpHeader } from 'src/services/clientIpService/getClientIp';

export const getPullUB04ServiceLog = async (body: IServiceLogGetParams) => {
  const token = await getAccessToken();
  const realm = getRealmName() ?? '';
  const getFacilityUuid = localStorage.getItem('facilityId');

  if (getFacilityUuid && getFacilityUuid.length) {
    body.facility_uuid = getFacilityUuid;
  }

  body.enterprise_name = realm;
  body.batch_type = 'UB04';

  const url = `${baseAutomationUrl}${serviceLogMatrixPath.PULL_UB04_SERVICE_LOG}`;

  return axios.post(url, body, {
    headers: {
      Authorization: `Bearer ${token}`,
      ...(await getClientIpHeader()),
    },
    responseType: 'arraybuffer',
  });
};
